import React, { useState } from "react";
import {Link, Outlet, useLocation, useNavigate} from "react-router-dom";
import Footer from "./Footer";
import Notification from "./utils/Notification";
import {useAuthStore, useRegister} from "./stores/authStore";

const Header = () => {
    const [show, setShow] = useState(false);
    const [open, setOpen] = useState(false);
    const [openM, setOpenM] = useState(false);
    const navigate = useNavigate();
    const { logout } = useRegister()
    const token = localStorage.getItem("access_token");
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const location = useLocation();
    const isCreatePage = location.pathname === "/detail/create/" || location.pathname === "/detail/profile" || location.pathname === "/detail/change";
    const toggleMenu = () => {
        setShow((prev) => !prev);
        setOpenM((prev) => !prev);
    }

    return (
        <div className="shadow-md bg-[#F7F7F7]">
            <div className="container h-[122px] px-10 flex items-center justify-between relative">
                <Link className="flex justify-center" to={"/"}>
                    <img className="w-20 h-[70px]" src={'/image.png'} alt="Логотип Aluu Satuu" />
                </Link>

                <button
                    onClick={toggleMenu}
                    className="md:hidden w-1/2 flex justify-end"
                >
                    {show ? (
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 6L18 18M6 18L18 6"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    ) : (
                        <svg
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M4 18L20 18M4 12L20 12M4 6L20 6"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    )}
                </button>
                <nav className="hidden md:flex flex-row items-center gap-10 text-xl text-[#000000A6] font-semibold">
                    <Link to={"/"}>Главная</Link>
                    <Link to="/detail/blog/">Блог</Link>
                    <Link to="/detail/contact/">Контакты</Link>
                    {user && Object.keys(user).length > 0 && (<Link to="/detail/profile">Профиль</Link>)}
                </nav>
                {isCreatePage && token ? (
                    <div className="relative inline-block">
                        <button
                            className="hidden md:block text-[#000000A6] font-semibold"
                            onClick={() => setOpen(!open)}
                        >
                            {user.email}
                        </button>
                        {open && (
                            <div className="absolute right-0 w-48 rounded-md z-50">
                                <button
                                    className="w-full text-left px-2 hover:bg-gray-100 rounded-md"
                                    onClick={() => {
                                        navigate('/detail/change/');
                                    }}
                                >
                                    Сменить пароль
                                </button>
                                <button
                                    className="w-full text-left px-2 text-red-600 hover:bg-gray-100 rounded-md"
                                    onClick={() => {
                                        logout();
                                        navigate('/');
                                    }}
                                >
                                    Выйти из аккаунта
                                </button>
                            </div>
                        )}
                    </div>
                ) : (
                    <Link
                        to={token ? "/detail/create/" : "/detail/login/"}
                        className="hidden md:block"
                    >
                        <button className="button1 font-bold bg-[#3d9cf8] py-[10px] px-5 tracking-[1px] rounded-[20px]">
                            СОЗДАТЬ ОБЪЯВЛЕНИЯ
                        </button>
                    </Link>
                )}
            </div>

            <div
                className={`transition-all duration-500 ease-in-out overflow-hidden md:hidden 
          ${show ? "max-h-[500px] py-4" : "max-h-0 py-0"}
        `}
            >
                <div className="flex flex-col items-center gap-4 bg-[#F7F7F7] md:text-xl text-[#000000A6] font-semibold">
                    <Link onClick={toggleMenu} to={"/"}>
                        Главная
                    </Link>
                    <Link onClick={toggleMenu} to={"/detail/blog/"}>
                        Блог
                    </Link>
                    <Link onClick={toggleMenu} to={"/detail/contact/"}>
                        Контакты
                    </Link>
                    {user && Object.keys(user).length > 0 && (<Link onClick={toggleMenu} to={"/detail/profile"}>
                        Профиль
                    </Link>)}
                    {isCreatePage && token ? (
                        <div className="flex flex-col items-center">
                            <button
                                className="text-[#000000A6] font-semibold"
                            >
                                {user.email}
                            </button>
                            <button
                                className="w-fit text-right hover:bg-gray-100 rounded-md"
                                onClick={() => {
                                    navigate('/detail/change');
                                }}
                            >
                                Сменить пароль
                            </button>
                            <button
                                className="w-fit text-right text-red-600 hover:bg-gray-100 rounded-md"
                                onClick={() => {
                                    logout();
                                    navigate('/');
                                }}
                            >
                                Выйти
                            </button>
                        </div>

                    ) : (
                        <Link
                            onClick={toggleMenu}
                            to={token ? "/detail/create/" : "/detail/login/"}
                        >
                            <button className="button1 font-bold bg-[#3d9cf8] py-[10px] px-5 tracking-[1px] rounded-[20px]">
                                СОЗДАТЬ ОБЪЯВЛЕНИЯ
                            </button>
                        </Link>
                    )}
                </div>
            </div>
            <Outlet />
            <Footer />
            <Notification/>
        </div>
    );
};

export default Header;
